import { webTypeApiUrl } from "@/constants/webTypeApiUrl";

export const LeadHandler = {
  name: "LeadHandler",
  GetLead: function (leadSn, staffid) {
    var leadInfo_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/GetLead",
      type: "post",
      cache: false,
      async: false,
      data: {
        leadSn: leadSn,
        staffId: staffid
      },
      dataType: "json",
      success: function (data) {
        leadInfo_ = data.Result;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return leadInfo_;
  },
  queryLeadInfo: function (form, tutorChatToken) {
    var queryReasult_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/QueryLeadInfo",
      type: "post",
      cache: false,
      async: false,
      data: {
        email: form.email,
        phone: form.cellPhone,
        tutorChatToken: tutorChatToken
      },
      dataType: "json",
      success: function (data) {
        queryReasult_ = data.Result;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return queryReasult_;
  },
  bindLeadAndSocialLead: function (socialLeadId, queryReasult, tutorChatToken, compulsory) {
    var queryReasult_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/bindLeadAndSocialLead",
      type: "post",
      cache: false,
      async: false,
      data: {
        socialLeadId: socialLeadId,
        leadSn: queryReasult.LeadSn,
        compulsory: compulsory,
        tutorChatToken: tutorChatToken
      },
      dataType: "json",
      success: function (data) {
        if (data.Success) {
          queryReasult_ = "已成功綁定。";
        } else {
          queryReasult_ = data.DisplayMessage;
        }
        if (data.ErrorNumber == 30) {
          if (confirm("一般名單與社群名單的主聯業務不同人，確定是否強制綁定?")) {
            queryReasult_ = LeadHandler.bindLeadAndSocialLead(socialLeadId, queryReasult, tutorChatToken, true)
          }
        }
      },
      error: function (data) {
        queryReasult_ = "綁定發生錯誤，請洽資訊人員。";
      }
    });
    return queryReasult_;
  },
  addSalesTraceStatus: function (leadSn, tutorChatToken) {
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/AddSalesTraceStatus",
      type: "post",
      cache: false,
      async: false,
      data: {
        leadSn: leadSn,
        tutorChatToken: tutorChatToken
      },
      dataType: "json",
      success: function (data) {},
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
  },
  getLeadSourceOptions: function (brandId, tutorChatToken) {
    var Options_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/GetLeadSourceOptions",
      type: "post",
      cache: false,
      async: false,
      data: {
        brandId: brandId,
        tutorChatToken: tutorChatToken
      },
      dataType: "json",
      success: function (data) {
        Options_ = data.Result;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return Options_;
  },
  getMediaOptions: function (brandId, tutorChatToken) {
    var Options_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/GetMediaOptions",
      type: "post",
      cache: false,
      async: false,
      data: {
        brandId: brandId,
        tutorChatToken: tutorChatToken
      },
      dataType: "json",
      success: function (data) {
        Options_ = data.Result;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return Options_;
  },
  getAgeRangeOptions: function (brandId, tutorChatToken) {
    var Options_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/GetAgeRangeOptions",
      type: "post",
      cache: false,
      async: false,
      data: {
        brandId: brandId,
        tutorChatToken: tutorChatToken
      },
      dataType: "json",
      success: function (data) {
        Options_ = data.Result.Options;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return Options_;
  },
  getMediaItemOptions: function (brandId, mediaSn, tutorChatToken) {
    var Options_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/GetMediaItemOptions",
      type: "post",
      cache: false,
      async: false,
      data: {
        brandId: brandId,
        mediaSn: mediaSn,
        tutorChatToken: tutorChatToken
      },
      dataType: "json",
      success: function (data) {
        Options_ = data.Result;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return Options_;
  },
  getMarketMediaOptions: function (brandId, mediaItemSn, tutorChatToken) {
    var Options_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/GetMarketMediaOptions",
      type: "post",
      cache: false,
      async: false,
      data: {
        brandId: brandId,
        mediaItemSn: mediaItemSn,
        tutorChatToken: tutorChatToken
      },
      dataType: "json",
      success: function (data) {
        Options_ = data.Result;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return Options_;
  },
  //這個一鍵註冊的按鈕只會把名單註冊到stage環境中，
  //Dev的資料不會變更，所以當你發現註冊失敗時，
  //請把名單資訊丟至stage中查詢看看是否有註冊成功。
  signUp: function (leadSn, tutorChatToken) {
    var signUpReasult_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/SignUp",
      type: "post",
      cache: false,
      async: false,
      data: {
        leadSn: leadSn,
        tutorChatToken: tutorChatToken
      },
      dataType: "json",
      success: function (data) {
        signUpReasult_ = data.Success;
      },
      error: function () {
        alert("註冊發生錯誤，請洽技術人員。");
      }
    });
    return signUpReasult_;
  },
  createLead: function (form, tutorChatToken) {
    var signUpReasult_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/CreateLead",
      type: "post",
      cache: false,
      async: false,
      data: {
        chineseName: form.name,
        Email: form.email,
        PhoneNumber: form.cellPhone,
        Sex: form.sex,
        AgeRange: form.ageRange,
        BrandId: form.brand,
        ChannelId: form.leadSource,
        MarketMediaSn: form.marketMedia,
        tutorChatToken: tutorChatToken
      },
      dataType: "json",
      success: function (data) {
        if (data.Success) {
          signUpReasult_ = data.Result;
        } else {
          alert("新增失敗，請確認資料或是聯絡資訊人員。");
        }
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return signUpReasult_;
  },
  getInvitationPageInfo: function (leadSn, tutorChatToken, ProviderId) {
    var InvitationPageInfo_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/SCRMApp/GetInvitationPageInfo",
      type: "post",
      cache: false,
      async: false,
      data: {
        leadSn: leadSn,
        tutorChatToken: tutorChatToken,
        ProviderId: ProviderId
      },
      dataType: "json",
      success: function (data) {
        if (data.Success) {
          InvitationPageInfo_ = data.Result;
        } else {
          alert("請勿在短時間內請勿重覆發送好友邀請函，請按上一頁。")
        }
      },
      error: function (a, b, c) {}
    });
    return InvitationPageInfo_;
  }
};



// WEBPACK FOOTER //
// ./src/handler/LeadHandler.js